import SwitcherContainer from "../../../../../src/entities/UI/SwitcherContainer";
import { eventBus, EnumEventBus } from "../managers/EventBus";


export default class SegmentSwitcherCon extends SwitcherContainer {
  constructor() {
    super({ 
      header: "Segment Mode", 
      coords: { vertical: { x: 0, y: 760 }, horizontal: { x: 160, y: 240 } },
      handleFunc: (v: boolean) => eventBus.emit(EnumEventBus.segmentMode, v)
    });
  }
}